// extracted by mini-css-extract-plugin
export default {"paginate":"UploadedVideosPagination_paginate__CFMgy"};